import React from 'react';
import {
  IconCheckCircle,
  IconReportHeptagon,
  IconAlertTriangle,
  IconInfoCircle,
  IconClose,
} from '@/icons';
import * as Styles from './Toast.styles';

export const contextList = {
  positive: 'positive',
  neutral: 'neutral',
  alert: 'alert',
  negative: 'negative',
  error: 'error',
};

export const getIconBasedOnContext = (context = 'positive') => ({
  [contextList.positive]: <IconCheckCircle />,
  [contextList.neutral]: <IconInfoCircle />,
  [contextList.alert]: <IconAlertTriangle />,
  [contextList.negative]: <IconReportHeptagon />,
  [contextList.error]: <IconInfoCircle color="#FFFFFF" />,
})[context];

export const Toast = ({
  index,
  title = 'Title',
  info = 'This is brief feedback displayed at the bottom of the screen after an operation.',
  actionLabel = 'action',
  showIcon = false,
  context = 'positive',
  onClose,
  onActions = {},
  labelPrimaryButton = 'Accept',
  labelSecondaryButton = 'Cancel',
  forceClosing = false,
}) => (
  <Styles.Container open error={context === 'error'} index={index} isClosing={forceClosing}>
    {showIcon ? (
      getIconBasedOnContext(context)
    ) : null}
    <Styles.Text>
      <div>
        {title ? (
          <Styles.Title context={context}>{title}</Styles.Title>
        ) : null}
        {info ? (
          <Styles.Info>{info}</Styles.Info>
        ) : null}
      </div>
      {onActions.onAccept && onActions.onCancel ? (
        <Styles.Buttons>
          <Styles.Button data-testid="btn-accept" onClick={onActions.onAccept} variant="primary">
            {labelPrimaryButton}
          </Styles.Button>
          <Styles.Button data-testid="btn-cancel" onClick={onActions.onCancel} variant="secondary">
            {labelSecondaryButton}
          </Styles.Button>
        </Styles.Buttons>
      ) : null}
    </Styles.Text>
    {onActions.onSingleAction && !(onActions.onAccept && onActions.onCancel) ? (
      <Styles.Actions>
        {actionLabel}
      </Styles.Actions>
    ) : null}
    {onClose ? (
      <Styles.Close hasActionsButton={Object.values(onActions).length} onClick={onClose}>
        <IconClose color="#FFFFFF" size={24} />
      </Styles.Close>
    ) : null }
  </Styles.Container>
);
